import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom"; // Add for navigation

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-about">
          <img
            className="imagefooter"
            src="images/footerlogo.png"
            alt="Umraah Taxi Services"
          />
          {/* <h2>Umraah Taxi Services</h2> */}
          <p>
            Umraah Taxi Services offers affordable and reliable taxi services
            all across Saudi Arabia, especially for Hajj and Umrah pilgrims.
          </p>
        </div>

        <div className="footer-menu">
          <h3>Quick Links</h3>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/packages">Packages</Link>
            </li>
            {/* <li><Link to="/shop">Shop</Link></li> */}
            <li>
              <Link to="/about-us">About Us</Link>
            </li>
            {/* <li><Link to="/blog">Blog</Link></li> */}
            <li>
              <Link to="/contact-us">Contact Us</Link>
            </li>
          </ul>
        </div>

        <div className="footer-contact">
          <h3>Contact Info</h3>
          <ul>
            <li>
              <a href="mailto:umraahtaxiservices@gmail.com">
                Email: umraahtaxiservices@gmail.com
              </a>
            </li>
            <li>
              <a href="tel:+923291396691">Phone: +923095153707</a>
            </li>
            <li>Address: Makkah, Saudi Arabia</li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2024 Umraah Taxi Services. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
